import routesService from "../shared/services/routesService";
import routeTrtipControlPointService from "../shared/services/routeTripControlPoint.service";
import { clearCreatePontrolPoint as onClearCreatePontrolPoint } from "./createContolPointActions";
import { unselectTrip as onUnselectTrip } from "./tripsActions";

const REQUEST_ROUTES = "REQUEST_ROUTES";
const RESPONSE_ROUTES = "RESPONSE_ROUTES";
const REQUEST_ROUTES_FAILURE = "REQUEST_ROUTES_FAILURE";

const requestRoutesAction = () => {
  return {
    type: REQUEST_ROUTES,
  };
};

const responseRoutesAction = (data) => {
  return {
    type: RESPONSE_ROUTES,
    data,
  };
};

const requestRoutesFailureAction = (errors) => {
  return {
    type: REQUEST_ROUTES_FAILURE,
    errors,
  };
};

const getRoutes = (options) => {
  return (dispatch) => {
    dispatch(unselectRoute());
    dispatch(requestRoutesAction());

    routesService
      .getRoutes(options)
      .then((result) => {
        const data = routeTrtipControlPointService.routes(result.data);

        dispatch(responseRoutesAction(data));
      })
      .catch((error) => {
        dispatch(requestRoutesFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_ROUTE = "REQUEST_CREATE_ROUTE";
const RESPONSE_CREATE_ROUTE = "RESPONSE_CREATE_ROUTE";
const REQUEST_CREATE_ROUTE_FAILURE = "REQUEST_CREATE_ROUTE_FAILURE";

const requestCreateRouteAction = () => {
  return {
    type: REQUEST_CREATE_ROUTE,
  };
};

const responseCreateRouteAction = (data) => {
  return {
    type: RESPONSE_CREATE_ROUTE,
    data,
  };
};

const requestCreateRouteFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_ROUTE_FAILURE,
    errors,
  };
};

const createRoute = (options) => {
  return (dispatch) => {
    dispatch(unselectRoute());
    dispatch(requestCreateRouteAction());

    routesService
      .createRoute(options)
      .then((result) => {
        options.id = result.data.id;
        dispatch(responseCreateRouteAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateRouteFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_ROUTE = "REQUEST_DELETE_ROUTE";
const RESPONSE_DELETE_ROUTE = "RESPONSE_DELETE_ROUTE";
const REQUEST_DELETE_ROUTE_FAILURE = "REQUEST_DELETE_ROUTE_FAILURE";

const requestDeleteRouteAction = () => {
  return {
    type: REQUEST_DELETE_ROUTE,
  };
};

const responseDeleteRouteAction = (data) => {
  return {
    type: RESPONSE_DELETE_ROUTE,
    data,
  };
};

const requestDeleteRouteFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_ROUTE_FAILURE,
    errors,
  };
};

const deleteRoute = (options) => {
  return (dispatch) => {
    dispatch(unselectRoute());
    dispatch(requestDeleteRouteAction());

    routesService
      .deleteRoute(options)
      .then((result) => {
        dispatch(responseDeleteRouteAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteRouteFailureAction(error.response));
      });
  };
};

const SEARCH_TERM_ROUTE_OPTIONS = "SEARCH_TERM_ROUTE_OPTIONS";

const searchTermRouteOptionsAction = (data) => {
  return {
    type: SEARCH_TERM_ROUTE_OPTIONS,
    data,
  };
};

const changeSearchTerm = (searchTerm) => {
  return (dispatch) => {
    dispatch(searchTermRouteOptionsAction(searchTerm));
    dispatch(onClearCreatePontrolPoint());
  };
};

const ORDER_DEASC_ROUTE_OPTIONS = "ORDER_DEASC_ROUTE_OPTIONS";

const orderDescRouteOptionsAction = (data) => {
  return {
    type: ORDER_DEASC_ROUTE_OPTIONS,
    data,
  };
};

const changeOrderDesc = (orderDesc) => {
  return (dispatch) => {
    dispatch(orderDescRouteOptionsAction(orderDesc));
    dispatch(onClearCreatePontrolPoint());
  };
};

const ON_SELECT_ROUTE = "ON_SELECT_ROUTE";

const onSelectRouteAction = (data) => {
  return {
    type: ON_SELECT_ROUTE,
    data,
  };
};

const selectRoute = (data) => {
  return (dispatch) => {
    dispatch(onSelectRouteAction(data));
    dispatch(onClearCreatePontrolPoint());
    dispatch(onUnselectTrip());
  };
};

const ON_UNSELECT_ROUTE = "ON_UNSELECT_ROUTE";

const onUnselectRouteAction = () => {
  return {
    type: ON_UNSELECT_ROUTE,
    data: null,
  };
};

const unselectRoute = () => {
  return (dispatch) => {
    dispatch(onUnselectRouteAction());
    dispatch(onClearCreatePontrolPoint());
    dispatch(onUnselectTrip());
  };
};

export {
  REQUEST_ROUTES,
  RESPONSE_ROUTES,
  REQUEST_ROUTES_FAILURE,
  getRoutes,
  REQUEST_CREATE_ROUTE,
  RESPONSE_CREATE_ROUTE,
  REQUEST_CREATE_ROUTE_FAILURE,
  createRoute,
  REQUEST_DELETE_ROUTE,
  RESPONSE_DELETE_ROUTE,
  REQUEST_DELETE_ROUTE_FAILURE,
  deleteRoute,
  SEARCH_TERM_ROUTE_OPTIONS,
  changeSearchTerm,
  ORDER_DEASC_ROUTE_OPTIONS,
  changeOrderDesc,
  ON_SELECT_ROUTE,
  selectRoute,
  ON_UNSELECT_ROUTE,
  unselectRoute,
};
